import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "f-input" }
const _hoisted_2 = { class: "h-full relative flex items-center cursor-text hover:text-gray-700" }
const _hoisted_3 = ["value", "type", "autofocus", "disabled", "placeholder"]
const _hoisted_4 = {
  key: 1,
  class: "text-gray-700"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["box-border cursor-text rounded text-gray-400 border-current py-1 px-2 mb-1 text-base h-10 transition-colors", {
        'border': !_ctx.isFocused,
        'text-primary border-2': _ctx.isFocused,
        'border-red-500': !_ctx.obeyRules,
        'cursor-not-allowed': _ctx.disabled,
      }]),
      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.handleClickTextField && _ctx.handleClickTextField(...args)))
    }, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.label !== undefined)
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: _normalizeClass(["text-gray-400 transition-all absolute left-0 origin-top-left py-0 px-1 transform bg-white", {
            '-translate-y-4 scale-75': _ctx.shouldLabelFloating,
            'text-primary': _ctx.isFocused,
          }])
            }, _toDisplayString(_ctx.label), 3))
          : _createCommentVNode("", true),
        _createElementVNode("input", {
          ref: "input",
          class: _normalizeClass(["border-none outline-none text-gray-700 w-full", { 'text-red-500': !_ctx.obeyRules, 'cursor-not-allowed': _ctx.disabled }]),
          value: _ctx.modelValue,
          type: _ctx.type,
          autofocus: _ctx.autofocus,
          disabled: _ctx.disabled,
          placeholder: _ctx.placeholder,
          onInput: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleChangeValue && _ctx.handleChangeValue(...args))),
          onFocus: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.handleInputFocused && _ctx.handleInputFocused(...args))),
          onBlur: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.handleInputBlured && _ctx.handleInputBlured(...args)))
        }, null, 42, _hoisted_3),
        (_ctx.suffix !== undefined)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.suffix), 1))
          : _createCommentVNode("", true)
      ])
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass({
        'flex justify-between items-center py-0 px-3': !_ctx.disabled,
        'h-3 text-xs break-words text-gray-500': !_ctx.disabled,
      })
    }, [
      _createVNode(_Transition, {
        "enter-active-class": "transition-all ease-out transform duration-300",
        "enter-from-class": "-translate-y-2 opacity-0",
        "leave-active-class": "transition-all ease-out transform duration-300",
        "leave-to-class": "-translate-y-2 opacity-0"
      }, {
        default: _withCtx(() => [
          _withDirectives(_createElementVNode("span", {
            class: _normalizeClass({ 'text-red-500': !_ctx.obeyRules })
          }, _toDisplayString(_ctx.obeyRules ? _ctx.hint : _ctx.warningMessage), 3), [
            [_vShow, _ctx.isHintVisible || !_ctx.obeyRules]
          ])
        ]),
        _: 1
      })
    ], 2)
  ]))
}